import {Component, OnInit, input} from '@angular/core';

@Component({
    selector: 'exl-html-display',
    templateUrl: './html-display.component.html',
    styleUrls: ['./html-display.component.scss'],
    standalone: true
})
export class HtmlDisplayComponent implements OnInit {

    readonly content = input<string>(undefined);

    constructor() { }

    ngOnInit() {
    }

}
